import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Account } from "@app/models/account";
import { AccountFilter } from '@app/models/account-filter';
import { AccountService } from "@app/services/account.service";
import { GlobalErrorHandlerService } from "@app/services/global-error-handler.service";
import { NotificationService } from "@app/services/notification.service";
import { OffBalanceAccountService } from '@app/services/off-balance-account.service';

@Component({
    selector: 'app-user-account-list-table',
    templateUrl: './user-account-list-table.component.html',
    styleUrls: ['./user-account-list-table.component.css'],
    standalone: false
})
export class UserAccountListTableComponent implements OnInit, OnChanges {

  @Input() accountFilter: AccountFilter;
  @Input() hideClosedAccount: boolean;
  @Input() isForeignCurrencyAccount: boolean;
  @Input() selectedAccount: any;
  @Input() kindOfAccountType: number;
  @Input() currency: string;
  @Output() addAccount = new EventEmitter<Account>();

  errorMessage: string | boolean;
  infoMessage: string;
  pageSize: number = 25;
  pageIndex:number = 0;
  totalElements = 0;
  accounts: Array<Account> = [];

  defaultPageParams = {
    size: 25,
    page: 0
  }

  constructor(
      private accountService: AccountService,
      private offBalanceAccountService: OffBalanceAccountService,
      private notificationService: NotificationService,
      private errorService: GlobalErrorHandlerService
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['accountFilter'] && !changes['accountFilter'].firstChange) {
      this.pageIndex = 0;
      this.getAccounts();
    }
  }

  loadAccounts(event) {
    if (event) {
      this.pageIndex = Math.floor(event.first / event.rows);
      this.pageSize = event.rows;
      this.getAccounts();
    }
  }

  getAccounts() {
    this.accounts = [];
    
    if (this.currency) {
      if (!this.accountFilter) {
        this.accountFilter = new AccountFilter();
      }
      this.accountFilter.currency = this.currency;
    }

    if (this.kindOfAccountType != 1) {
      this.getOffBalanceAccountsList();
    }
    if (this.kindOfAccountType != 2) {
      this.getNormalAccountsList();
    }
  }

  getOffBalanceAccountsList() {
    const pageOption = {
      size: this.pageSize,
      page: this.pageIndex,
      sorted: true,
      parent: true
    }

    const pageParams = { ...this.defaultPageParams, ...pageOption, ...this.accountFilter };
    this.offBalanceAccountService.getList(pageParams).subscribe({
      next: (data) => {
        this.accounts = this.accounts.concat(data.content);
        this.totalElements = data.totalElements;
        if (this.hideClosedAccount) {
          this.accounts = this.accounts.filter(p => p.status == "ACTIVE");
        }
      },
      error: (err) => {
        this.errorMessage = this.errorService.handleError(err);
        if(this.errorMessage)
        this.notificationService.showError("<div class='row'><p class='col-1 d-flex align-items-center'><i class='fa fa-times-circle'></i></p><p class='col'> " + `${this.errorMessage}` + "</p></div>",
                "");
      }
    });
  }

  getNormalAccountsList() {
    const pageOption = {
      size: this.pageSize,
      page: this.pageIndex,
      sorted: true,
      parent: true
    }

    const pageParams = { ...this.defaultPageParams, ...pageOption, ...this.accountFilter };
    this.accountService.getList(pageParams).subscribe({
      next: (data) => {
        this.accounts = data.content.concat(this.accounts).filter(p => p.accountType.enabled);
        this.totalElements = data.totalElements;
        if (this.isForeignCurrencyAccount) {
          this.accounts = this.accounts.filter(p => !p.currency?.default);
        }
        if (this.hideClosedAccount) {
          this.accounts = this.accounts.filter(p => p.status == "ACTIVE");
        }
      },
      error: (err) => {
        this.errorMessage = this.errorService.handleError(err);
        if(this.errorMessage)
        this.notificationService.showError("<div class='row'><p class='col-1 d-flex align-items-center'><i class='fa fa-times-circle'></i></p><p class='col'> " + `${this.errorMessage}` + "</p></div>",
                "");
      }
    });
  }

  composeAccounts(account: Account) {
    if (account) {
      this.addAccount.emit(account)
    }
  }
  
}
